import styled from "@emotion/styled";
import { Icon } from "../atoms/Icon";

interface TitleSectionProps {
  title?: string;
  subtitle?: string;
  description?: string;
  showAlert?: boolean;
  className?: string;
  backButtonAction?: () => void;
}

const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing(2)};
  width: 100%;
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
`;

const Title = styled.h2`
  margin: 0;
  flex: 1;
  font-family: ${(props) => props.theme.typography.fontFamily};
  font-size: ${(props) => props.theme.typography.h6.fontSize};
  font-weight: ${(props) => props.theme.typography.h6.fontWeight};
  line-height: ${(props) => props.theme.typography.h6.lineHeight};
  color: ${(props) => props.theme.colors.neutral.white};
`;

const AlertIcon = styled.div`
  position: absolute;
  top: -0.5rem;
  right: 0;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`;

const SubtitleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing(1)};
`;

const Subtitle = styled.p`
  margin: 0;
  font-family: ${(props) => props.theme.typography.fontFamily};
  font-size: ${(props) => props.theme.typography.body1Bold.fontSize};
  font-weight: ${(props) => props.theme.typography.body1Bold.fontWeight};
  line-height: ${(props) => props.theme.typography.body1Bold.lineHeight};
  color: ${(props) => props.theme.colors.neutral.white};
`;

const Description = styled.p`
  margin: 0;
  font-family: ${(props) => props.theme.typography.fontFamily};
  font-size: ${(props) => props.theme.typography.body3Regular.fontSize};
  font-weight: ${(props) => props.theme.typography.body3Regular.fontWeight};
  line-height: ${(props) => props.theme.typography.body3Regular.lineHeight};
  color: ${(props) => props.theme.colors.text.mediumEmphasis};
`;

const BackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  width: 24px;
  :focus {
    outline: none;
  }
  :focus-visible {
    outline: none;
  }
  :active {
    outline: none;
  }
  :hover {
    outline: none;
  }
`;

export const TitleSection = ({
  title = "Oferta personalizada",
  subtitle = "Tu grupo sí puede progresar",
  description = "Con pagos transparentes, ventajas exclusivas y el respaldo que siempre tendrás",
  showAlert = true,
  className,
  backButtonAction,
}: TitleSectionProps) => {
  return (
    <SectionContainer className={className}>
      <TitleRow>
        {backButtonAction && (
          <BackButton onClick={backButtonAction}>
            <Icon name="back" color="primary" size={24} />
          </BackButton>
        )}
        <Title>{title}</Title>
        {showAlert && (
          <AlertIcon>
            <Icon name="alert" color="primary" size={24} />
          </AlertIcon>
        )}
      </TitleRow>

      <SubtitleSection>
        <Subtitle>{subtitle}</Subtitle>
        <Description>{description}</Description>
      </SubtitleSection>
    </SectionContainer>
  );
};
